module.exports = __webpack_public_path__ + "static/media/pure_sp.3bf29a9c.jpg";